import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CaissePrelevement } from '../models/caissePrelevement';
import { CaisseDepot } from '../models/caisseDepot';

@Injectable({ providedIn: 'root' })
export class CaissierService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }


}
